import { Zap, Shield, DollarSign } from "lucide-react";
import MobilePaymentCard from "./sections/mobile-payment-card";
import BillingSection from "./sections/billing-section";
import BillingFeaturesDetail from "./sections/billing-features-detail";
import BillingPaymentFlow from "./sections/billing-payment-flow";
import CTASection from "../../components/cta-section";
import { useTranslation } from "../../i18n";

export default function Home() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen overflow-x-hidden">
      {/* Gradient Background */}
      <div className="absolute inset-0 -z-10 bg-gradient-to-br from-green-500 via-emerald-600 to-teal-500 opacity-90" />

      {/* Diagonal White Section */}
      <div className="absolute top-0 left-0 right-0 h-[800px] -z-5">
        <div className="absolute top-0 left-0 right-0 h-full bg-white transform -skew-y-6 origin-top-left translate-y-[30%]" />
      </div>

      {/* Main Content */}
      <main className="relative z-10 px-4 md:px-8 pt-32 pb-24">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="text-4xl md:text-6xl font-bold text-navy-900 leading-tight">
              {t('routes.billing.heroTitle')} <br />
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-violet-600 via-purple-600 to-orange-500">
                {t('routes.billing.heroHighlight')}
              </span>
            </h1>
            <p className="mt-6 text-gray-700 text-lg">
              {t('routes.billing.heroDescription')}
            </p>

            <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="flex items-center">
                <div className="h-10 w-10 flex-shrink-0 mr-3 rounded-full bg-green-100 flex items-center justify-center">
                  <Zap className="h-5 w-5 text-green-600" />
                </div>
                <span className="text-sm font-medium">
                  {t('routes.billing.heroBulletPoints.0')}
                </span>
              </div>
              <div className="flex items-center">
                <div className="h-10 w-10 flex-shrink-0 mr-3 rounded-full bg-blue-100 flex items-center justify-center">
                  <Shield className="h-5 w-5 text-blue-600" />
                </div>
                <span className="text-sm font-medium">
                  {t('routes.billing.heroBulletPoints.1')}
                </span>
              </div>
              <div className="flex items-center">
                <div className="h-10 w-10 flex-shrink-0 mr-3 rounded-full bg-purple-100 flex items-center justify-center">
                  <DollarSign className="h-5 w-5 text-purple-600" />
                </div>
                <span className="text-sm font-medium">
                  {t('routes.billing.heroBulletPoints.2')}
                </span>
              </div>
            </div>
          </div>

          <div className="flex justify-center">
            <div className="relative">
              <MobilePaymentCard />
              <div className="absolute -right-32 -bottom-16 w-80 h-64"></div>
            </div>
          </div>
        </div>
      </main>

      {/* JUHUU Billing Main Section */}
      <BillingSection />

      {/* Detailed Features */}
      <BillingFeaturesDetail />

      {/* Payment Flow Visualization */}
      <BillingPaymentFlow />

      {/* CTA Section */}
      <CTASection />
    </div>
  );
}
